import React, { useState } from 'react';
import { Eye, Loader2 } from 'lucide-react';
import { useViewAs } from './ViewAsContext';

/** Opens the apps as a role or person would see them. Only a Superadmin gets it. */
export default function ViewAsButton({ target, path = '/app/home', className = '', children = 'See their screen' }) {
  const viewAs = useViewAs();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);
  if (!viewAs?.canViewAs || !target || target === `person:${viewAs.selfProfileId}`) return null;
  const open = async () => {
    setPending(true);
    setError(null);
    try {
      await viewAs.start(target, { path });
    } catch (failure) {
      setError(failure.message);
      setPending(false);
    }
  };
  return <>
    <button type="button" onClick={open} disabled={pending} className={className} data-testid="view-as-button">
      {pending ? <Loader2 size={14} className="animate-spin" aria-hidden="true" /> : <Eye size={14} aria-hidden="true" />}
      {children}
    </button>
    {error && <p role="alert" className="text-xs text-red-700">{error}</p>}
  </>;
}
